import searchLogo from "../assets/images/searchLogo.svg";
import {
  myValueFormatter,
  myValueFormatter_quantity,
} from "./commonFunctions";
import { dtcStatusColors } from "./constants";
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import _ from "lodash";
import AllocationPercentageRenderer from "../components/AllocationPercentageRenderer";

export const LoanRetunsColumnDefs = [
  {
    headerName: "Acc Id",
    field: "account_id",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return params.values[0];
    },
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    minWidth: 70,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
      };
    },
  },
  {
    headerName: "Callback Id",
    field: "callbacks_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 95,
    maxWidth: 95,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Activity Id",
    field: "activity_id",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: "flex",
      alignItems: "center",
      borderRight: "1px solid #DFDFDF",
    },
    minWidth: 90,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cpty Id",
    field: "cpty_id",
    enableRowGroup: true,
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return "(" + _.uniq(params.values).length + ")";
      }
      else {
        return "(0)";
      }
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 77,
    maxWidth: 85,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Ticker",
    field: "ticker",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return params.values[0];
    },
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 68,
    maxWidth: 100,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Cusip",
    field: "cusip",
    floatingFilter: false,
    rowGroup: true,
    hide: true,
    enableRowGroup: true,
    sort: 'desc',
    filter: "agSetColumnFilter",
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        return "(" + _.uniq(params.values).length + ")";
      }
      else {
        return "(0)";
      }
    },
    comparator: (a: any, b: any, nodeA: any, nodeB: any, isDescending: any) => {
      if (nodeA?.allChildrenCount && nodeB?.allChildrenCount) {
        if (nodeA?.allChildrenCount === nodeB?.allChildrenCount) return 0;
        return (nodeA?.allChildrenCount > nodeB?.allChildrenCount) ? 1 : -1;
      }
      return;
    },
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 80,
    maxWidth: 80,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Callback Qty",
    field: "callback_quantity",
    aggFunc: 'sum',
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 100,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Callback Val",
    type: "rightAligned",
    field: "callback_amount",
    aggFunc: 'sum',
    floatingFilter: false,
    editable: false,
    hide:true,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 120,
    maxWidth: 150,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Delivery Date",
    field: "delivery_date",
    floatingFilter: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 105,
    maxWidth: 105,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Allocated Status",
    field: "allocated_status",
    floatingFilter: false,
    filter: "agSetColumnFilter",
    editable: false,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 120,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Allocations",
    field: 'allocationPercentage',
    aggFunc: 'sum',
    floatingFilter: false,
    sortable: true,
    editable: false,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellRenderer: AllocationPercentageRenderer,
    minWidth: 95,
    cellStyle: function (params: any) {
      return {
        borderRight: "0.5px solid #E1E1E1"
      };
    },
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Return Qty",
    field: "return_quantity",
    aggFunc: 'sum',
    type: "rightAligned",
    floatingFilter: false,
    editable: false,
    filter: "agNumberColumnFilter",
    valueFormatter: myValueFormatter_quantity,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
        justifyContent: "flex-end",
      };
    },
    minWidth: 93,
    maxWidth: 130,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Return Val",
    field: "return_amount",
    aggFunc: 'sum',
    floatingFilter: false,
    type: "rightAligned",
    filter: "agNumberColumnFilter",
    editable: false,
    valueFormatter: myValueFormatter,
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #DFDFDF",
        justifyContent: "flex-end",
      };
    },
    minWidth: 115,
    maxWidth: 140,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Dtc Status",
    field: "return_dtc_status",
    floatingFilter: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values)) {
        let firstStatus = params.values[0];
        let otherStatuses = _.pull(params.values, firstStatus);
        return _.isEmpty(otherStatuses) ? firstStatus : "Pended";
      }
      return "Pended";
    },
    filter: "agSetColumnFilter",
    editable: false,
    pinned: 'right',
    lockPinned: true,
    cellClass: "lock-pinned",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      if (params?.data?.return_dtc_status?.toLowerCase() === "settled" || params?.value === "Settled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #E1E1E1",
          backgroundColor: dtcStatusColors.settled
        };
      }
      if (params?.data?.return_dtc_status?.toLowerCase() === "pended" || params?.value === "Pended") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.pended
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "rad") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.RAD
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "approved") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.approved
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "reversed") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.reversed
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "dropped") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.dropped
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "non-ccf") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.nonCcf
        };
      } if (params?.data?.return_dtc_status?.toLowerCase() === "canceled") {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
          backgroundColor: dtcStatusColors.canceled
        };
      } else {
        return {
          display: "flex",
          alignItems: "center",
          borderRight: "0.5px solid #DFDFDF",
        };
      }
    },
    minWidth: 90,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Callback Updated By",
    field: "callback_updated_by",
    hide: true,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 120,
    maxWidth: 120,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Callback Update By",
    field: "callback_updated_by",
    floatingFilter: false,
    editable: false,
    hide: true,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Callback Updated Date",
    field: "callbackUpdatedDate",
    floatingFilter: false,
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Callback Created Date",
    field: "callbackCreatedDate",
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Return Update By",
    field: "return_updated_by",
    floatingFilter: false,
    editable: false,
    filter: "agSetColumnFilter",
    hide: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  },
  {
    headerName: "Return Update Date",
    field: "returnUpdatedDate",
    floatingFilter: false,
    editable: false,
    aggFunc: (params: any) => {
      if (params && params.values && !_.isEmpty(params.values))
        return _.max(params.values);
    },
    filter: "agSetColumnFilter",
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: function (params: any) {
      return {
        display: "flex",
        alignItems: "center",
        borderRight: "0.5px solid #E1E1E1",
      };
    },
    minWidth: 135,
    maxWidth: 135,
    suppressSizeToFit: false,
    icons: {
      menu: `<img src="${searchLogo}" />`,
    },
  }
];